import { render, staticRenderFns } from "./Flex.vue?vue&type=template&id=17e8b810"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports